"use client";

import * as React from "react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useRightTabs } from "@/contexts/right-tabs-context";
import Header from "@/components/nav/header";

/**
 * Header Wrapper - Fixed header across top of page
 */
export function HeaderWrapper() {
  const pathname = usePathname();

  // Hide on certain pages if needed
  const hideHeader =
    pathname?.startsWith("/admin") ||
    (pathname?.startsWith("/listing/") && false);

  if (hideHeader) return null;

  return (
    <header className="fixed left-0 right-0 top-0 z-[var(--z-header)] h-16 border-b bg-indigo-400/60  backdrop-blur-md">
      <div className="mr-1h-full bg- ml-2 bg-indigo-400/60 sm:px-6 lg:px-8">
        <Header />
      </div>
    </header>
  );
}
